import {assert} from 'Asserts';
import {
  DataFrameFilterCondition,
  DataFrameFilterOperation,
  OPERATOR_EQUIVALENCES,
  UserFacingFilter,
} from 'data-frames/filters/DataFrameFilterTypes';
import pick from 'util/pick';
import {JSONValue} from 'util/Types';

export function convertToInternalFilterInterface(condition: DataFrameFilterCondition): UserFacingFilter {
  const operatorEquivalence = [...OPERATOR_EQUIVALENCES].find(
    ([_, {operation, not_}]) => operation === condition.operation && not_ === condition.not_
  );
  assert(operatorEquivalence != null, `Unexpected filter condition ${pick(condition, 'operation', 'not_')}`);

  return {
    columnSystemName: condition.columnSystemName,
    operator: operatorEquivalence[0],
    value: condition.operation !== DataFrameFilterOperation.IS_NULL ? condition.value : null,
  };
}

export function convertFromInternalFilterInterface(
  userFacingFilter: UserFacingFilter
): DataFrameFilterCondition {
  const {operation, not_} = OPERATOR_EQUIVALENCES.get(userFacingFilter.operator)!;
  const columnSystemName = userFacingFilter.columnSystemName;

  if (operation === DataFrameFilterOperation.IS_NULL) {
    return {columnSystemName, operation, not_};
  } else if (operation === DataFrameFilterOperation.IS_IN) {
    assert(Array.isArray(userFacingFilter.value), 'Expected value for IS_IN filter to be an array');
    return {columnSystemName, operation, not_, value: userFacingFilter.value as Array<JSONValue>};
  } else {
    return {columnSystemName, operation, not_, value: userFacingFilter.value as JSONScalar};
  }
}
